// extracted by mini-css-extract-plugin
export default {"root":"RescheduleClassesFilterChips_root__Ajwd+"};